import AssetSeized from './AssetSeized';

export default AssetSeized;
